import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import {SnackbarProvider} from "notistack";
import GSPSNotification from "Components/Notifications/GSPSNotification";
import {store} from "app/store";
import {Provider} from "react-redux";
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration()],

        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        // tracesSampleRate: 1.0,
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <SnackbarProvider
            maxSnack={3}
            Components={{
                success: GSPSNotification,
                error: GSPSNotification,
            }}
        >
            <Provider store={store}>
                <App />
            </Provider>
        </SnackbarProvider>
    </React.StrictMode>,
);
